module.exports = __webpack_public_path__ + "static/Whistle_Volara_Co-Marketing_Flyer.a60854f5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Whistle_Volara_Co-Marketing_Flyer.pdf
// module id = 73
// module chunks = 31532440822795 35783957827783 230781006321697